import React, { useState, useEffect } from "react";
import "./NewProducts.css";
import ProductCard from "../../components/ProductCard/ProductCard";
import Loaderdots from "../../components/LoaderDots/Loaderdots";
import { Link, useLocation } from "react-router-dom";

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const categoryFilter = params.get("category");
  const colorGroupFilter = params.get("colorGroup");

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://riymay.com/api/v1/user/products?limit=100");
        const data = await response.json();

        let filtered = data.products.filter((p) => p.visibility === "public");

        if (categoryFilter) {
          filtered = filtered.filter(
            (p) => p.category && p.category.toLowerCase() === categoryFilter.toLowerCase()
          );
        }

        if (colorGroupFilter) {
          filtered = filtered.filter(
            (p) => p.colorGroup && p.colorGroup.toLowerCase() === colorGroupFilter.toLowerCase()
          );
        }

        setProducts(filtered);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryFilter, colorGroupFilter]);

  if (loading) return <div><Loaderdots /></div>;

  return (
    <div>
      {(categoryFilter || colorGroupFilter) && (
        <p style={{ textAlign: "center", padding: "20px 0 0", fontSize: "13px", letterSpacing: "0.2em", textTransform: "uppercase", color: "#666" }}>
          {categoryFilter || colorGroupFilter}
        </p>
      )}
      <div className="product-grid">
        {products.length > 0 ? (
          products.map((product, index) => (
            <Link className="product-card-container" key={product._id} to={`/product/${product._id}`}>
              <ProductCard key={`${product._id}${index}`} product={product} />
            </Link>
          ))
        ) : (
          <div className="pg-empty">
            <p className="pg-empty-title">Nothing here yet</p>
            <p className="pg-empty-text">
              {colorGroupFilter
                ? `No pieces are tagged ${colorGroupFilter} at the moment.`
                : categoryFilter
                ? `No pieces in ${categoryFilter} at the moment.`
                : "No products available."}
            </p>
            <Link to="/newproduct" className="pg-empty-link">View all products</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductGrid;